import React from "react";
// import "../styles/404.css";

const NotFound = () => {
  return (
    <div className="container">
      <h1>404</h1>
      <div className="emoji">😵‍💫</div>
      <p>Uh-oh! The page you’re looking for is as lost as you are.</p>
      <a href="/">Go Back Home</a>
    </div>
  );
};

export default NotFound;
